"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));
var _colors = _interopRequireDefault(require("@fe/ui/colors"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const styles = {
  container: {
    display: 'flex',
    height: '100vh',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    width: '100%',
    minWidth: 300,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  textBlock: {
    paddingTop: '1em'
  }
};
const ContactUsLink = () => /*#__PURE__*/_react.default.createElement("a", {
  href: "mailto:support@glfr.com"
}, "Contact Us");
const LoginLink = () => /*#__PURE__*/_react.default.createElement("a", {
  href: "/login"
}, "Log In");
const NoSuchUser = _ref => {
  let classes = _ref.classes,
    _ref$loggedIn = _ref.loggedIn,
    loggedIn = _ref$loggedIn === void 0 ? false : _ref$loggedIn;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement(_Paper.default, {
    className: classes.paper
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h3",
    style: {
      display: 'flex',
      alignItems: 'center',
      color: _colors.default.primaryDarkRed,
      fontWeight: 'bold'
    }
  }, "Out of bounds!"), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h6",
    className: classes.textBlock
  }, "We looked for the user you tried to view, but it seems you were out of bounds."), loggedIn ? /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h6",
    className: classes.textBlock
  }, "The user you are looking for may have a private profile which means no one else can see their data.") : /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h6",
    className: classes.textBlock
  }, "The user you are looking for may have set their privacy settings to Private or Buddies Only. If you ", /*#__PURE__*/_react.default.createElement(LoginLink, null), " you might be able to see this page."), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h6",
    className: classes.textBlock
  }, "Please check the link and ", /*#__PURE__*/_react.default.createElement(ContactUsLink, null), " if you think something is wrong.")));
};
var _default = exports.default = (0, _withStyles.default)(styles)(NoSuchUser);